import { ReactNode } from 'react'
import {
  MetricsCardStyled,
  MetricsCardHeader,
  MetricsValue,
} from './MetricsCard.styled'

type MetricCardProps = {
  title: ReactNode
  value: string | number
}

export const MetricsCard: React.FC<MetricCardProps> = ({ title, value }) => (
  <MetricsCardStyled>
    <MetricsCardHeader>{title}</MetricsCardHeader>
    <MetricsValue>{value}</MetricsValue>
  </MetricsCardStyled>
)
